import React from 'react'
import { DefaultLayout } from '../../layouts'
import { Button, SimplePageHeader } from '../../components'
import { Link } from 'react-router-dom'

const NotFound = () => {
  return (
    <DefaultLayout>
      <SimplePageHeader noPadding />

      <div className="text-center py-10 lg:py-20">
        <h1 className="text-4xl lg:text-6xl text-gray-text mb-8 font-bold">404</h1>
        <img src="/images/404.svg" className="mb-8" alt="KHUB - 404 Not Found"/>
        <div className="px-5 lg:px-0">
          <p className="text-sm text-gray-666 mb-8">
            The page you are trying to access does not exist or has been moved. <br />
            Try going back to our homepage.
          </p>
          <Link to="/">
            <Button className="inline-block w-full lg:w-auto uppercase mb-16" style={{minWidth: '270px'}}>
              Back to Homepage
            </Button>
          </Link>
        </div>
      </div>
    </DefaultLayout>
  )
}

export { NotFound }
